import { BaseClient, RequestConfig } from "./BaseClient";

import forIn from "lodash/forIn";
import set from "lodash/set";
import flow from "lodash/flow";
import map from "lodash/fp/map";
import join from "lodash/fp/join";
import { AxiosResponse } from "axios";

import {
    ExactMatchParams,
    IntranetLayer,
    IntranetLayerParams,
    IntranetLayersParams,
    IntranetSuggestResponse,
} from "../models/intranet-search";

export default class IntranetSearchClient extends BaseClient {
    static readonly DEFAULT_BASE_URL = "https://search.yandex-team.ru";
    static readonly API_URL = "";

    static readonly SUGGEST_URL = `${IntranetSearchClient.API_URL}/suggest`;

    constructor(baseUrl?: string) {
        super(baseUrl || IntranetSearchClient.DEFAULT_BASE_URL);
    }

    protected async sendRequest(requestConfig: RequestConfig): Promise<AxiosResponse> {
        requestConfig.paramsSerializer = { indexes: null };
        return await super.sendRequest(requestConfig);
    }

    async suggest(request: {
        text?: string;
        allowEmpty?: boolean;
        language?: "ru" | "en";
        layers?: IntranetLayersParams;
    }): Promise<AxiosResponse<IntranetSuggestResponse>> {
        const { allowEmpty: allow_empty, layers, ...restParams } = request;

        const layersList: string[] = [];
        forIn(layers, (layerParams: IntranetLayerParams, layer: string) => {
            layersList.push(layer);

            const exactMatchParam = ExactMatchParams[layer as IntranetLayer];

            const exactMatchQuery =
                flow(
                    map((v) => `${exactMatchParam}:"${v}"`),
                    join(" | "),
                )(layerParams.exactMatch) || undefined;
            set(restParams, ["language"], layerParams.language);
            set(restParams, [`${layer}.page`], layerParams.page);
            set(restParams, [`${layer}.per_page`], layerParams.perPage);
            set(restParams, [`${layer}.query`], layerParams.query || exactMatchQuery);
        });

        const params = {
            allow_empty,
            layers: layersList,
            version: 2,
            ...restParams,
        };
        const requestConfig: RequestConfig = {
            method: "GET",
            url: IntranetSearchClient.SUGGEST_URL,
            params: params,
        };

        return await this.sendRequest(requestConfig);
    }
}
